import { render, staticRenderFns } from "./TranscriptQueueTaskNote.vue?vue&type=template&id=67654221&"
import script from "./TranscriptQueueTaskNote.vue?vue&type=script&lang=js&"
export * from "./TranscriptQueueTaskNote.vue?vue&type=script&lang=js&"
import style0 from "./TranscriptQueueTaskNote.vue?vue&type=style&index=0&id=67654221&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports